import React from 'react';
import DieFace from '../DieFace';
import { GameState } from '../../types';
import { getPlayerDisplayName } from '../../utils/playerUtils';
import { PANEL_STYLES, HEADING_STYLES, SUBHEADING_STYLES } from '../../constants/styles';

interface CurrentBidDisplayProps {
  gameState: GameState;
}

const CurrentBidDisplay: React.FC<CurrentBidDisplayProps> = ({ gameState }) => {
  const currentBid = gameState.currentBid;

  const getBidderName = (): string => {
    if (!currentBid) return '';
    const bidder = gameState.players.find(p => p.id === currentBid.playerId);
    return bidder ? getPlayerDisplayName(bidder.name, gameState.players) : '';
  };

  return (
    <div className={PANEL_STYLES}>
      <h2 className={`${HEADING_STYLES} mb-1`}>Current Bid</h2>
      {currentBid ? (
        <div className="flex items-center justify-center gap-2">
          <div className="text-2xl font-bold text-gray-900 dark:text-white">
            {currentBid.quantity}
          </div>
          <div className="text-lg text-gray-500 dark:text-gray-400">×</div>
          <DieFace value={currentBid.faceValue} size="sm" />
          <p className={`${SUBHEADING_STYLES} ml-2`}>
            by {getBidderName()}
          </p>
        </div>
      ) : (
        <p className={`${SUBHEADING_STYLES} text-center`}>No bid yet</p>
      )}
    </div>
  );
};

export default CurrentBidDisplay;